"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../../utils");

var DataSourceStore =
/** @class */
function () {
  function DataSourceStore() {
    this.sources = new Map();
    this.order = new Map();
    this.mapping = new Map();
  }

  Object.defineProperty(DataSourceStore.prototype, "count", {
    get: function () {
      return this.sources.keys.length;
    },
    enumerable: false,
    configurable: true
  });

  DataSourceStore.prototype.add = function (identifier, source, order) {
    this.sources.set(identifier, source);

    if ((0, _utils.isset)(order)) {
      this.order.set(identifier, order);
    }
  };

  DataSourceStore.prototype.remove = function (identifier) {
    this.sources.delete(identifier);
  };

  DataSourceStore.prototype.has = function (identifier) {
    return (0, _utils.isset)(this.get(identifier));
  };

  DataSourceStore.prototype.get = function (identifier) {
    var source = this.sources.get(identifier);

    if (!(0, _utils.isset)(source)) {
      var mapped = this.mapping.get(identifier);

      if (mapped) {
        source = this.sources.get(mapped);
      }
    }

    return source;
  };

  DataSourceStore.prototype.map = function (identifier, altIdentifier) {
    this.mapping.set(altIdentifier, identifier);
  };

  return DataSourceStore;
}();

var _default = DataSourceStore;
exports.default = _default;
module.exports = exports.default;